import { avatar, profileBG } from "utils/assets_exports/images";
import { CustomComponentProps } from "utils/types/general.types";
import { DemoUserListObject } from "assets/data/usersData";
import PlaceIcon from "@mui/icons-material/Place";

export type ProfileHeaderProps = CustomComponentProps & {
    user: DemoUserListObject;
};

const ProfileHeader = ({ user, className, style }: ProfileHeaderProps) => {
    return (
        <div className={`profile-header w-full ${className}`} style={style}>
            <div className="cover-bg relative">
                <img
                    className="cover-image"
                    src={profileBG}
                    alt="community cover picture"
                />
                <div className="avatar">
                    <img
                        id="user-avatar"
                        className="avatar-image"
                        src={user.url || avatar}
                        alt=""
                    />
                </div>
                <div className="cover-overlay"></div>
            </div>

            <div className="flex flex-col-reverse lg:flex-row gap-4  pt-20 lg:pt-10 justify-between items-center pb-10 px-3 text-gray-500 dark:text-gray-300 ">
                <div className="flex justify-between items-center lg:flex-col lg:justify-start lg:items-start w-full lg:w-fit first-subheader">
                    <div className="flex justify-start items-center">
                        <PlaceIcon
                            fontSize="small"
                            className="text-momeento-50"
                        />
                        <span>India</span>
                    </div>
                    <span>Joined: March 2024</span>
                </div>
                <div className="flex flex-col gap-1 justify-center items-center lg:items-end">
                    <h1 className="font-bold text-2xl  text-black dark:text-white">
                        {user.name}
                    </h1>
                    <span>@{user.username}</span>
                </div>
            </div>

            <div className="w-full flex justify-center items-center pb-5 px-3">
                <p className="font-light dark:text-white text-start">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Illum, numquam!
                </p>
            </div>
        </div>
    );
};

export default ProfileHeader;
